module.exports = __webpack_public_path__ + "img/long-term-cache/blank.2ecf731f7c0e3291792565aaa40b07d4.gif";